<!--
 * @Author: Hwc
 * @LastEditors: Hwc
 * @Description: 
-->
<template>
  <svg
    aria-hidden="true"
    :class="svgClass"
    v-on="$listeners"
  >
    <use :xlink:href="icon" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    // 用于菜单树-新增/编辑菜单时的icon选择
    isMenuIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icon () {
      return `#${this.isMenuIcon ? '' : 'lc_'}${this.iconClass}`
    },
    svgClass() {
      return `svg-icon ${this.className || ''}`.trimEnd();
    },
  }
}
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
